









































































































































































































































import MantenedorGridVerDetalle from '@/reusable/Grid/MantenedorGridVerDetalle.vue';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { ServicioProxy, Accion } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import PopUpGeneratedReports from './PopUpGeneratedReoports.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import { getUserId } from '@/pantallas/Conecta/MantenedorLocalidad/helpers/getUserId';
import { AxiosVue } from '@/AxiosVue';
import Confirmation from '@/components/Confirmation.vue';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { Data } from './Cuadratura.model';
import { Snotify } from '@/snotify/Snotify';
@Component({
  components: {
    MantenedorGridVerDetalle,
    PopUpGeneratedReports,
    Confirmation,
  },
})
export default class CuadreServicioForm extends Vue {
  @Prop() readonly patente!: string;
  @Prop() readonly detalleId: string;
  @Prop() readonly detalleglosa!: string;
  @Prop() readonly Categoriaglosa!: string;
  @Prop() readonly estado!: string;
  axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  datosComparativa: Data = null;
  serverSide: any;
  gridApi: GridApi;
  columnApi: ColumnApi;
  searchReport: string = '';
  msgReport: string = '';
  datosPlataforma = '';
  selectedCategoria: string = '';
  updatedGlosa: string = this.detalleglosa;
  updateCategoria: string = this.Categoriaglosa;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  enrichedGridOptions: GridOptions = null;
  showPopUpReport: boolean = false;
  readonly gridOptions: GridOptions;
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.CuadraturaOrdenesServicio;
  showDialog = false;
  confirmationTitle = '';
  confirmationMessage = '';
  categorias: Array<any> = [];
  isLoading: boolean = true;

  showConfirmation(action: string) {
    if (action === 'finalizar') {
      this.confirmationTitle = 'Confirmar Finalización';
      this.confirmationMessage = '¿Está seguro de que desea cambiar el estado?';
    } else if (action === 'guardarGlosa') {
      this.confirmationTitle = 'Confirmar Guardar Glosa';
      this.confirmationMessage = '¿Está seguro de que desea guardar glosa?';
    }
    this.showDialog = true;
  }

  handleConfirmationResponse(confirmed: boolean) {
    if (confirmed) {
      if (this.confirmationTitle === 'Confirmar Finalización') {
        this.updateEstado();
      } else if (this.confirmationTitle === 'Confirmar Guardar Glosa') {
        this.updateglosa();
      }
    }
    this.showDialog = false;
  }

  mounted() {
    this.cargarDatostabla();
    this.getplataforma();
    this.getCategoria();
  }

  //llamada al servicio getDatosComparativa para carfar los datos en los div
  cargarDatostabla() {
    this.axios.http
      .post('Metabase/PostgenericA/CuadraturaServicios/getDatosComparativa', {
        serienumero: this.patente,
      })
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.datosComparativa = response.data.data;
          console.log('Datos Comparativa: ', this.datosComparativa);
          this.isLoading = false;
        } else {
          console.error(
            'Error al cargar los datos de la tabla:',
            response.data.MENSAJE_RESPUESTA
          );
        }
      })
      .catch((error: any) => {
        console.error('Error al realizar la petición:', error);
      })
      .finally(() => {});
  }
  //------

  // Método para ajustar automáticamente el tamaño de las columnas
  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  onGlosaInput(value: string) {
    this.updatedGlosa = value; // Actualiza el valor de updatedGlosa cada vez que el usuario escribe en el textarea
  }

  //llamada al servicio updateCampoGlosa para actualizar la glosa de cuadratura_patentes
  updateglosa() {
    this.loadingService.showLoading();
    this.axios.http
      .post('Metabase/PostgenericA/CuadraturaServicios/updateCampoGlosa', {
        id: this.detalleId,
        glosa: this.updatedGlosa,
        tipocategoria: this.selectedCategoria,
      })
      .then((response: any) => {
        this.loadingService.hideLoading();
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success('Glosa y Categoría actualizados con éxito');
          this.$emit('glosaUpdated', {
            glosa: this.updatedGlosa,
            categoria: this.selectedCategoria,
          });
        } else {
          this.$snotify.error('Error al actualizar glosa');
          // En caso de que el código de respuesta no sea '1', maneja la respuesta como no exitosa
          console.error(
            'Error al actualizar:',
            response.data.MENSAJE_RESPUESTA
          );
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        // Maneja los errores que pueden ocurrir durante la petición HTTP
        console.error('Error al realizar la petición:', error);
      });
  }
  //--------
  getCategoria() {
    this.axios.http
      .post('Metabase/PostgenericA/CuadraturaServicios/getCampoCategoria')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.categorias = response.data.data;
          this.onCategoriaglosaChanged(this.Categoriaglosa, null);
        } else {
          this.$snotify.error('Error al actualizar glosa');
          console.error(
            'Error al actualizar:',
            response.data.MENSAJE_RESPUESTA
          );
        }
      })
      .catch((error: any) => {
        console.error('Error al realizar la petición:', error);
      });
  }
  //--------
  @Watch('Categoriaglosa', { immediate: true })
  onCategoriaglosaChanged(newVal: string | null, oldVal: string | null) {
    if (!newVal) return; // Si no hay valor nuevo o es nulo, no hacer nada.

    // Intenta encontrar una categoría que coincida por ID o por nombre.
    const foundCategory = this.categorias.find(
      cat => cat.id.toString() === newVal || cat.name === newVal
    );

    if (foundCategory) {
      // Si encuentra una coincidencia por ID o nombre, usa el ID como valor seleccionado.
      this.selectedCategoria = foundCategory.id;
    } else if (this.categorias.length > 0) {
      // Si no encuentra coincidencia pero las categorías están cargadas, y es un string directo, use el valor como está.
      this.categorias.push({ id: newVal, name: newVal });
      this.selectedCategoria = newVal;
    } else {
      // Si las categorías aún no están cargadas, configura un valor temporal o maneja según sea necesario.
      this.selectedCategoria = newVal;
    }
  }

  //llamada al servicio updateCampoGlosa para actualizar estado a finalizado
  updateEstado() {
    if (this.estado === 'Finalizado') {
      this.$snotify.success('El estado ya se encuentra Finalizado');
      return; // Salir del método si ya está finalizado
    }
    this.loadingService.showLoading();
    this.axios.http
      .post('Metabase/PostgenericA/CuadraturaServicios/updateCampoEstado', {
        id: this.detalleId,
      })
      .then((response: any) => {
        this.loadingService.hideLoading();
        if (response.data.CODIGO_RESPUESTA === '1') {
          this.$snotify.success(response.data.MENSAJE_RESPUESTA);
          this.$emit('updateEstado', 'Finalizado'); // Actualiza el estado en el frontend
        } else if (response.data.CODIGO_RESPUESTA === '2') {
          this.$snotify.success(response.data.MENSAJE_RESPUESTA);
        } else {
          this.$snotify.error('Error al actualizar estado');
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        console.error('Error al realizar la petición:', error);
        this.$snotify.error('Error de conexión con el servidor');
      });
  }

  //--------

  //peticion para mostrar datos en la grilla
  async onGridReadyy(params: GridReadyEvent) {
    this.gridApi = params.api; // Almacena la API de ag-Grid
    this.columnApi = params.columnApi; // Almacena la API de columnas de ag-Grid
    const self = this;

    this.serverSide = {
      getRows(params: any): void {
        params.request.search = self.searchReport;
        params.request.paginationPageSize = self.gridOptions.cacheBlockSize;
        const requestData = {
          startRow: params.request.startRow,
          endRow: params.request.endRow,
          serienumero: self.patente,
        };

        //console.log('Solicitud enviada al servicio:', requestData);
        self.axios.http
          .post('Metabase/PostgenericA/CuadraturaServicios/getCRM', {
            startRow: params.request.startRow,
            endRow: params.request.endRow,
            serienumero: self.patente,
          })
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '1') {
              self.gridApi.setRowData(response.data.data); // Actualiza los datos de la cuadrícula
              params.successCallback(
                response.data.data,
                response.data.data.length
              );
              self.autoSizeAll(false); // Ajusta automáticamente el tamaño de las col
              self.gridApi.hideOverlay();
            } else {
              // Lógica para manejar la respuesta fallida
              params.successCallback([{}], 0); // Ejecuta el callback de éxito con una matriz vacía
              self.gridApi.showNoRowsOverlay(); // Muestra la superposición cuando no hay filas
            }
            self.loadingService.hideLoading();
          })
          .catch((error: any) => {
            console.log(error);
          })
          .finally(() => {
            // Lógica a ejecutar después de la llamada HTTP
            self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading();
          });
      },
    };
    // Configura el lado del servidor para la cuadrícula
    this.gridApi.setServerSideDatasource(this.serverSide);
  }
  //-------

  //llamada al servicio updateCampoGlosa para actualizar la glosa de cuadratura_patentes
  getplataforma() {
    this.axios.http
      .post('Metabase/PostgenericA/CuadraturaServicios/getPlataforma', {
        serienumero: this.patente,
      })
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          console.log('Plataforma recibida:', response.data.data);
          this.datosPlataforma = response.data.data.plataforma;
        } else {
          this.datosPlataforma = 'No disponible';
          console.error(
            'Error al obtener la plataforma:',
            response.data.MENSAJE_RESPUESTA
          );
        }
      })
      .catch((error: any) => {
        console.error('Error al realizar la petición:', error);
      });
  }
  //--------

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  async getCSV(): Promise<void> {
    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');

    const body = {
      userId: userId,
      user: user,
      serienumero: this.patente,
    };

    this.loadingService.showLoading();

    try {
      const response = await this.axios.http.post(
        'Metabase/PostgenericA/CuadraturaServicios/export_excel_CRM',
        body
      );

      if (response.data && response.data.CODIGO_RESPUESTA === '1') {
        this.msgReport = response.data.MENSAJE_RESPUESTA;
        this.showPopUpReport = true;
      } else {
        this.$snotify.error(response.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      }
    } catch (error) {
      // Manejo de errores de red, servidor, etc.
      console.error('Error al generar el reporte:', error);
      this.$snotify.error(
        'Error al generar el reporte. Por favor, inténtelo de nuevo más tarde.',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }

  //Grilla CRM
  constructor() {
    super();
    this.gridOptions = {
      onGridReady: this.onGridReadyy, // Método que se ejecuta cuando la cuadrícula está lista
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50,
      cacheBlockSize: 50,
      paginationAutoPageSize: false,
      serverSideDatasource: this.serverSide,
      rowModelType: 'serverSide',
      columnDefs: [
        {
          headerName: 'Razon Social',
          field: 'razon_social',
        },
        {
          headerName: 'Serie',
          field: 'patente',
        },
        {
          headerName: 'Marca',
          field: 'marca',
        },
        {
          headerName: 'Modelo',
          field: 'modelo',
        },
        {
          headerName: 'Año',
          field: 'year',
        },
        {
          headerName: 'SIM',
          field: 'sim',
        },
        {
          headerName: 'Rut',
          field: 'rut',
        },
        {
          headerName: 'Estado',
          field: 'estado',
        },
        {
          headerName: 'Fecha Instalación',
          field: 'fecha_instalacion',
        },
        {
          headerName: 'Tipo Equipo',
          field: 'tipo_equipo',
        },
        {
          headerName: 'Flota',
          field: 'flota',
        },
      ],
    };
  }
}
